import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { AppConfig } from "./config";

/**
 * SEC-1 — the only identity provider. Supabase is used strictly for sign-in and token
 * refresh; all data goes through the Server (ARCH-1), never through PostgREST.
 */
export function createSupabaseClient(config: AppConfig): SupabaseClient {
  return createClient(config.supabaseUrl, config.supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // GitHub redirects back with the session in the URL fragment; let the client
      // pick it up and then tidy the address bar.
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  });
}

export async function signInWithGitHub(supabase: SupabaseClient): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "github",
    // Must be present in the Supabase redirect allow-list for this origin.
    options: { redirectTo: window.location.origin },
  });

  if (error) throw error;
}
